<template>
    <h1> Subscribe Management </h1>
</template>
<script>
export default {
    name: 'subscribeManagement'
}
</script>